import PCM from '../images/ncarb/pcm-horizontal.svg'
import PJM from '../images/ncarb/pjm-horizontal.svg'
import PA from '../images/ncarb/pa-horizontal.svg'
import PPD from '../images/ncarb/ppd-horizontal.svg'
import PDD from '../images/ncarb/pdd-horizontal.svg'
import CE from '../images/ncarb/ce-horizontal.svg'

import PCMIcon from '../images/icons/icon-pcm-color.svg'
import PJMIcon from '../images/icons/icon-pjm-color.svg'
import PAIcon from '../images/icons/icon-pa-color.svg'
import PPDIcon from '../images/icons/icon-ppd-color.svg'
import PDDIcon from '../images/icons/icon-pdd-color.svg'
import CEIcon from '../images/icons/icon-ce-color.svg'

import CERound from '../images/icons/icon-ce-color.svg'
import PJMRound from '../images/icons/icon-pjm-color.svg'
import PCMRound from '../images/icons/icon-pcm-color.svg'
import PDDRound from '../images/icons/icon-pdd-color.svg'
import PPDRound from '../images/icons/icon-ppd-color.svg'
import PARound from '../images/icons/icon-pa-color.svg'
import CSERound from '../images/icons/icon-cse-color.svg'

import CERoundGrey from '../images/icons/icon-ce.svg'
import PJMRoundGrey from '../images/icons/icon-pjm.svg'
import PCMRoundGrey from '../images/icons/icon-pcm.svg'
import PDDRoundGrey from '../images/icons/icon-pdd.svg'
import PPDRoundGrey from '../images/icons/icon-ppd.svg'
import PARoundGrey from '../images/icons/icon-pa.svg'
import CSERoundGrey from '../images/icons/icon-cse.svg'

export type VerticalObjectType = {
  PcM: string
  PjM: string
  PA: string
  PPD: string
  PDD: string
  CE: string
  CSE: string
}

export const NCARBAPPROVEDIMAGEABBR: VerticalObjectType = {
  PcM: PCM,
  PjM: PJM,
  PA: PA,
  PPD: PPD,
  PDD: PDD,
  CE: CE,
  CSE: CSERound,
}

export type DivisionNameType = {
  pcm: string
  pjm: string
  pa: string
  ppd: string
  pdd: string
  ce: string
  cse: string
}

export const DIVISION: DivisionNameType = {
  pcm: 'Practice Management',
  pjm: 'Project Management',
  pa: 'Programming & Analysis',
  ppd: 'Project Planning & Design',
  pdd: 'Project Development & Documentation',
  ce: 'Construction & Evaluation',
  cse: 'California Supplemental Exam',
}

export const DivisionColors = [
  {
    abbr: 'PcM',
    icon: PCMIcon,
    color: 'rgba(52,197,238,.2)',
  },
  {
    abbr: 'PjM',
    icon: PJMIcon,
    color: 'rgb(197,106,196,.2)',
  },
  {
    abbr: 'PA',
    icon: PAIcon,
    color: 'rgba(126,122,223,.25)',
  },
  {
    abbr: 'PPD',
    icon: PPDIcon,
    color: 'rgba(171,210,100,.25)',
  },
  {
    abbr: 'PDD',
    icon: PDDIcon,
    color: 'rgba(242,105,119,.25)',
  },
  {
    abbr: 'CE',
    icon: CEIcon,
    color: 'rgb(255,147,99,.2)',
  },
  {
    abbr: 'CSE',
    icon: CSERound,
    color: 'rgb(255,147,99,.2)',
  },
]

export type Divisions =
  | 'CE'
  | 'PA'
  | 'PJM'
  | 'PCM'
  | 'PjM'
  | 'PcM'
  | 'PPD'
  | 'PDD'
  | 'CSE'
  | null

export const getDivisionDetails = (division: Divisions) => {
  if (division === 'CE')
    return {
      icon: CERound,
      hoverIcon: CERoundGrey,
      name: 'Construction & Evaluation',
      mockExam:
        'https://www.blackspectacles.com/podcast/are-live-construction-evaluation-mock-exam-are-5.0-ce-exam-december-2024',
    }
  if (division === 'PPD')
    return {
      icon: PPDRound,
      hoverIcon: PPDRoundGrey,
      name: 'Project Planning & Design',
      mockExam:
        'https://www.blackspectacles.com/podcast/are-live-project-planning-design-mock-exam-are-5.0-ppd-exam-november-2024',
    }
  if (division === 'PDD')
    return {
      icon: PDDRound,
      hoverIcon: PDDRoundGrey,
      name: 'Project Development & Documentation',
      mockExam:
        'https://www.blackspectacles.com/podcast/are-live-project-development-documentation-mock-exam-are-pdd-exam-2025',
    }
  if (division === 'PA')
    return {
      icon: PARound,
      hoverIcon: PARoundGrey,
      name: 'Programming & Analysis',
      mockExam:
        'https://www.blackspectacles.com/podcast/are-live-programming-analysis-mock-exam-are-5.0-pa-exam-september-2024',
    }
  if (division === 'PCM' || division === 'PcM')
    return {
      icon: PCMRound,
      hoverIcon: PCMRoundGrey,
      name: 'Practice Management',
      mockExam:
        'https://www.blackspectacles.com/podcast/are-live-practice-management-mock-exam-are-5.0-pcm-exam-august-2024',
    }
  if (division === 'PJM' || division === 'PjM')
    return {
      icon: PJMRound,
      hoverIcon: PJMRoundGrey,
      name: 'Project Management',
      mockExam:
        'https://www.blackspectacles.com/podcast/are-live-project-management-mock-exam-are-5.0-pjm-exam-october-2024',
    }
  if (division === 'CSE')
    return {
      icon: CSERound,
      hoverIcon: CSERoundGrey,
      name: 'California Supplemental Exam',
    }
}
